import Vue from 'vue';
import { CHANNEL_MARKING } from '.././config';


let API_LAS_SECOO = process.env.API_LAS_SECOO || ''; //用户中心api
// console.log('=======================');
// console.log(API_LAS_SECOO);
// console.log('=======================');

//输入框默认提示文案
export function api_getKeywordRecommend(data){
    let api = API_LAS_SECOO + '/api/search/keyword_recommend';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.jsonp(api, {
        params: data
    });
};

//获取热门栏目推荐
export function api_getHotTopic(data){
    let api = '//lr.secooimg.com/hotTopic';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.jsonp(api, {
        params: data
    });
};

//热销推荐
export function api_getHotkey(data){
    let api = '//iphone.secoo.com/mobileservice/search/hotkey';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.jsonp(api, {
        params: data || {}
    });
};

/*
 * 问题：中台接口调用转发的范详大数据接口，现在大数据这块的接口没有device-id或upk，则不直接返回数据
 */
export function api_getCommRecommend(data){
    let api = API_LAS_SECOO + '/api/recommend/recommend_comm';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.jsonp(api, {
        params: data
    });

    // return new Promise((resolve, reject) => {
    //     setTimeout(function(){
    //         resolve({
    //             body: {
    //                 "retCode": 0,
    //                 "retMsg": "ok",
    //                 "requestId": "accede6f-a883-485c-94fa-6bc7ca84e158",
    //                 "mix": [
    //                     {"type":"1","orgCode":"_30_37_","name":"手拿包","id":37},
    //                     {"type":"1","orgCode":"_1799_1800_1832_","name":"美发工具","id":1832},
    //                     {"type":"1","orgCode":"_1690_1699_1756_","name":"女士连衣裙","id":1756},
    //                     {"type":"1","orgCode":"_1690_1691_1710_","name":"女士夹克","id":1710},
    //                     {"type":"1","orgCode":"_1690_1693_1847_","name":"女士针织衫\/毛衣","id":1847},
    //                     {"type":"1","orgCode":"_1690_1691_1712_","name":"女士马甲","id":1712}
    //                 ]
    //             }
    //         });
    //     }, 1000);
    // });
}

//猜你喜欢
export function api_getRecommend(data){
    let api = API_LAS_SECOO + '/api/recommend/recommend';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.jsonp(api, {
        params: data
    });
};

//搜索推荐-联想词 新suggest
export function api_getSearchSuggest(data){
    let api = API_LAS_SECOO + '/api/search/search_suggest';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.jsonp(api, {
        params: data || {}
    });
};

//搜索列表-关键词搜索
export function api_getSearchKeyword(data){
    // let api = '//las.secoo.com/api/search/keyword';
    // return Vue.http.jsonp(api, {
    //     params: data || {}
    // });

    let api = API_LAS_SECOO + '/api/search/keyword';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.post(api, data);
};

//搜索列表-分类搜索
export function api_getSearchCategory(data){
    // let api = '//las.secoo.com/api/search/category';
    // return Vue.http.jsonp(api, {
    //     params: data || {}
    // });

    let api = API_LAS_SECOO + '/api/search/category';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.post(api, data);
};

//搜索列表-品牌搜索
export function api_getSearchBrand(data){
    // let api = '//las.secoo.com/api/search/category';
    // return Vue.http.jsonp(api, {
    //     params: data || {}
    // });

    let api = API_LAS_SECOO + '/api/search/brand';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.post(api, data);
};

//搜索列表-优惠券搜索
export function api_getSearchTicket(data){
    // let api = '//las.secoo.com/api/search/category';
    // return Vue.http.jsonp(api, {
    //     params: data || {}
    // });

    let api = API_LAS_SECOO + '/api/search/ticket';
    data = data || {}
    data.c_appsource = CHANNEL_MARKING;

    return Vue.http.post(api, data);
};



// WEBPACK FOOTER //
// ./src/api/index.js